<app-dialog-base modalId="importFromGlobalModal" title="Import from global" modalSize="md"
    [itemTemplate]="importFromGlobalTemplate" [footerTemplate]="importFromGlobalFooter"></app-dialog-base>

<ng-template #importFromGlobalTemplate>
    <form #form="ngForm" name="form" role="form">
        <div *ngIf="!canImportFromGlobal" class="sdds-row">
            <p class="text-red-500">You need to have at least the System owner role in order to import specifications
                from Global</p>
        </div>

        <div *ngIf="loading" class="import-banner">
            <mat-icon fontSet="material-icons-outlined" class="md-18">info</mat-icon>
            <span>Import in progress, do not refresh or close the browser</span>
        </div>
        <div *ngIf="canImportFromGlobal" class="sdds-row" [ngClass]="{'import-locked': loading}">

            <p>This feature allows you to import a diagnostic specification that exists in the global instance of DCode.</p>
            <br />
            <br />
            <!-- Section 1: Specification to import -->
            <div class="sdds-col-max-12 sdds-no-padding sdds-form-field">
                <h6 class="font-bold">1. Specification to import</h6>                
                <div class="sdds-col-max-12 sdds-on-white-bg sdds-no-padding sdds-form-field my-5">                    
                    <label class="sdds-dropdown-label-outside">Select a specification from global</label>
                    <div class="import-dropdown" #dropdownContainer>
                        <div class="import-dropdown-control" (click)="toggleDropdown()">
                            <input class="import-dropdown-input" type="text" name="specificationSearch"
                                autocomplete="off" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
                                (click)="$event.stopPropagation()" placeholder="Search specification by name...">
                            <mat-icon fontSet="material-icons-outlined" class="md-18">
                                {{ dropdownOpen ? 'expand_less' : 'expand_more' }}
                            </mat-icon>
                        </div>
                        <ul class="import-dropdown-list" *ngIf="dropdownOpen">
                            <ng-container *ngFor="let group of filteredGroups">
                                <li class="import-dropdown-group">{{ group.label }}</li>
                                <li *ngFor="let specification of group.specifications" class="import-dropdown-item"
                                    [class.selected]="selectedSpecification?.id === specification.id"
                                    (click)="selectSpecification(specification)">
                                    {{ specification.name }}
                                </li>
                            </ng-container>
                            <li *ngIf="filteredGroups.length === 0" class="import-dropdown-empty">
                                No specifications found
                            </li>
                        </ul>
                    </div>
                    <span *ngIf="!selectedSpecification" class="text-red-500">* Required</span>                    
                </div>

                <div *ngIf="hasSelectedSpecification"
                    class="sdds-col-max-12 sdds-on-white-bg sdds-no-padding sdds-form-field my-5">
                    <label class="sdds-dropdown-label-outside">Target specification name</label>
                    <input class="import-name-input" type="text" name="targetSpecificationName" autocomplete="off"
                        [(ngModel)]="targetSpecificationName"
                        [ngClass]="{'import-name-valid': isTargetNameValid, 'import-name-invalid': !isTargetNameValid}">
                    <span *ngIf="isTargetNameTaken" class="text-red-500">Another specification has this name
                        already</span>
                    <span *ngIf="!isTargetNameTaken && isTargetNameTooShort" class="text-red-500">* A minimum of 3
                        characters is required</span>
                </div>

                <div *ngIf="hasSelectedSpecification" class="sdds-checkbox-item my-5"
                    title="Clones the ODX Translation ID and the Specification GUID from the source">
                    <input class="sdds-form-input" type="checkbox" name="preserveIds" id="preserveIds"
                        [(ngModel)]="preserveIds">
                    <label class="sdds-form-label" for="preserveIds"
                        title="Clones the ODX Translation ID and the Specification GUID from the source">Preserve IDs</label>
                    <span *ngIf="isPreserveIdsCodeConflict" class="text-red-500 ml-10">There is another specification
                        with the same id ({{ conflictingCode }})</span>
                </div>

                <div *ngIf="hasSelectedSpecification" class="sdds-radio-button-group my-5">
                    <div class="sdds-radio-item">
                        <input class="sdds-form-input" type="radio" name="versionMode" id="importLatestVersion"
                            value="latest" [(ngModel)]="versionMode">
                        <label class="sdds-form-label" for="importLatestVersion">Import latest released version</label>
                    </div>
                    <div class="sdds-radio-item">
                        <input class="sdds-form-input" type="radio" name="versionMode" id="importCustomVersion"
                            value="custom" [(ngModel)]="versionMode">
                        <label class="sdds-form-label" for="importCustomVersion">Import custom version</label>
                    </div>

                    <div *ngIf="versionMode === 'custom'"
                        class="sdds-dropdown sdds-dropdown-small sdds-on-white-bg my-5">
                        <label class="sdds-dropdown-label-outside">Select a version</label>
                        <select name="versionList" [(ngModel)]="selectedVersion">
                            <option [ngValue]="undefined" disabled>Select a version</option>
                            <option *ngFor="let version of availableVersions" [ngValue]="version">
                                {{ version.name }}
                            </option>
                        </select>
                        <span *ngIf="!selectedVersion" class="text-red-500">* Required</span>
                    </div>
                </div>
            </div>

            <!-- Section 2: Data to import -->
            <div class="sdds-col-max-12 sdds-no-padding sdds-form-field mt-10">
                <h6 class="font-bold">2. Data to import</h6>
                <div [ngClass]="{'opacity-50 pointer-events-none': !hasSelectedSpecification}">
                    <div class="sdds-checkbox-item my-5">
                        <input class="sdds-form-input" type="checkbox" name="importDiagnosticServices"
                            id="importDiagnosticServices" [(ngModel)]="importDiagnosticServices"
                            [disabled]="!hasSelectedSpecification">
                        <label class="sdds-form-label" for="importDiagnosticServices">Diagnostic Services</label>
                    </div>
                    <div class="sdds-checkbox-item my-5">
                        <input class="sdds-form-input" type="checkbox" name="importServers" id="importServers"
                            [(ngModel)]="importServers" [disabled]="!hasSelectedSpecification || isSourceBootloader">
                        <label class="sdds-form-label" for="importServers">Servers</label>
                        <span *ngIf="isSourceBootloader" class="font-bold text-gray-500 ml-10">(required for Bootloader
                            specifications)</span>
                    </div>
                    <div class="sdds-checkbox-item my-5">
                        <input class="sdds-form-input" type="checkbox" name="importCategoryItems"
                            id="importCategoryItems" [(ngModel)]="importCategoryItems"
                            [disabled]="!hasSelectedSpecification">
                        <label class="sdds-form-label" for="importCategoryItems">Category Items</label>
                    </div>
                    <div class="sdds-checkbox-item my-5">
                        <input class="sdds-form-input" type="checkbox" name="importRbaccFile" id="importRbaccFile"
                            [(ngModel)]="importRbaccFile" [disabled]="!hasSelectedSpecification">
                        <label class="sdds-form-label" for="importRbaccFile">Rbacc file</label>
                        <span *ngIf="hasRbaccGuidConflict" class="text-red-500 ml-10">The rbacc {{ conflictingRbaccGuid
                            }} already exist, connect it manually</span>
                    </div>
                </div>
                <span *ngIf="hasSelectedSpecification && !hasSelectedData" class="text-red-500">
                    * Select at least one type of data to import
                </span>
            </div>

            <!-- Section 3: Feedback -->
            <div class="sdds-col-max-12 sdds-no-padding sdds-form-field mt-10">
                <h6 class="font-bold">3. Progress</h6>
                <p *ngIf="!importInProgress" class="text-gray-500">No import running.</p>
                <ul *ngIf="importInProgress" class="import-progress-list">
                    <li *ngFor="let step of importSteps" class="import-progress-step">
                        <span class="import-progress-icon">
                            <span *ngIf="step.status === importStepStatus.Executing" class="import-spinner"></span>
                            <mat-icon *ngIf="step.status === importStepStatus.Complete"
                                fontSet="material-icons-outlined" class="md-18 import-icon-complete">check_circle</mat-icon>
                            <mat-icon *ngIf="step.status === importStepStatus.Failed"
                                fontSet="material-icons-outlined" class="md-18 import-icon-failed">cancel</mat-icon>
                        </span>
                        <span class="import-progress-text"
                            [ngClass]="{'text-gray-400': step.status === importStepStatus.Pending}">
                            {{ step.text }}
                            <span *ngIf="step.message" class="import-progress-message">— {{ step.message }}</span>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #importFromGlobalFooter>
    <!-- Idle / in progress -->
    <button *ngIf="!importCompleted && !importFailed && canImportFromGlobal" slot="sdds-modal-actions"
        class="sdds-btn sdds-btn-primary sdds-btn-md mr-12" (click)="import()" [disabled]="!canImport">Import</button>

    <!-- Import succeeded -->
    <button *ngIf="importCompleted" slot="sdds-modal-actions" class="sdds-btn sdds-btn-primary sdds-btn-md mr-12"
        (click)="finish()">Finish</button>

    <!-- A step other than "Create specification" failed -->
    <button *ngIf="importFailed && !importFailedAtCreation" slot="sdds-modal-actions"
        class="sdds-btn sdds-btn-primary sdds-btn-md mr-12" (click)="finish()" [disabled]="restoring">Finish with
        errors</button>
    <button *ngIf="importFailed && !importFailedAtCreation" slot="sdds-modal-actions"
        class="sdds-btn sdds-btn-danger sdds-btn-md mr-12" (click)="restoreAndClose()" [disabled]="restoring">Restore and
        Close</button>

    <!-- The critical "Create specification" step failed -->
    <button *ngIf="importFailed && importFailedAtCreation" slot="sdds-modal-actions"
        class="sdds-btn sdds-btn-primary sdds-btn-md mr-12" (click)="cancel()">Exit</button>

    <!-- Cancel is only available while idle -->
    <button *ngIf="!importCompleted && !importFailed" slot="sdds-modal-actions"
        class="sdds-btn sdds-btn-secondary sdds-btn-md" (click)="cancel()" [disabled]="loading">Cancel</button>

    <!-- Always-present hidden dismiss button. It is wired by sdds-modal on init, so emitting
         modalClosing from any action closes the dialog even for dynamically shown buttons. -->
    <button slot="sdds-modal-actions" data-dismiss-modal class="hide-element" style="display: none;" appCloseModal
        [close]="modalClosing"></button>
</ng-template>